import React, { useEffect, useState } from "react";
import { FxPopupOpener } from "./FxWindows";
import { FxResource } from "../inputs/FxResource";

export const FxPopup = (props) => {

  const { openRef, title, opObj, selectedData, selectedDataId } = props;

  return <FxPopupOpener openRef={openRef} title={title} refIndex={props.refIndex}>
    <FxResource
      opObj={opObj}
      selectedData={selectedData}
      selectedDataId={selectedDataId}
    />
  </FxPopupOpener>
}